import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { apiConstant } from '../app.constant';
import { FinancialSummary } from '../app.model';


@Injectable({
  providedIn: 'root'
})
export class FinancialSummaryService {

  constructor(private http: HttpClient) { }

  getFinancialSummary(month?: string) {

    const params: any = {};

    if (month) {
      params.month = month;
    }

    let apiUrl = `${environment.baseUrl + apiConstant.FINANCIAL_SUMMARY}`;

    return this.http.get<FinancialSummary>(apiUrl, { params });
  }
}
